import { MemberStatus } from '@lucidlink/dto/validation';
import { prepareAcceptSsoInvitationForExistingMemberDto, prepareAcceptSsoInvitationForNewMemberDto, } from '../../current-user-management/invitations/prepare-accept-sso-invitation-dto';
export async function acceptSsoInvitation(params) {
    const { userKey, domainKey, ssoInvitation, ssoFetcher } = params;
    if (!ssoInvitation.member) {
        const acceptInvitationDto = await prepareAcceptSsoInvitationForNewMemberDto({
            domainKey,
            acceptableSsoInvitationData: ssoInvitation,
            userKey,
        });
        await ssoFetcher.post(['invitations', 'sso', 'members'], {
            body: acceptInvitationDto,
        });
        return;
    }
    if (ssoInvitation.member.status !== MemberStatus.PENDING) {
        return;
    }
    const acceptInvitationDto = await prepareAcceptSsoInvitationForExistingMemberDto({
        domainKey,
        acceptableSsoInvitationData: ssoInvitation,
        userKey,
    });
    await ssoFetcher.patch(['invitations', 'sso', 'members'], {
        body: acceptInvitationDto,
    });
}
